export default __webpack_public_path__ + "static/media/seal-authorize copy.93547f25.png";